import React, { useState } from 'react'
import PageHeader from '../../components/PageHeader'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { IconButton, Tooltip } from '@mui/material';
import AddAppointment from './AddAppointment';
import FilterPoint from './FilterPoint';
import MedicalRecord from './MedicalRecord';
import TakeHistory from './TakeHistory';
import SeeDoctor from './SeeDoctor';
import Appointment from './Appointment';
import DispenseMedication from './DispenseMedication';
import { useLocation, useNavigate } from 'react-router'
import { useDispatch } from 'react-redux';
import { menuActive  } from '../../store/menuSlice';
import { useEffect } from 'react';
import LoaderAnimation from '../../components/LoaderAnimation';
import * as api from '../../services/OutPatient/ApiFilterPoint';
import { notifyError, notifyInfo, notifySuccess } from '../../components/NotifyToast';
import NewAppoint from './NewAppoint';

import { IoMdAddCircleOutline } from "react-icons/io";
import { GrSchedules, GrScheduleNew } from "react-icons/gr";
import { MdChecklistRtl } from "react-icons/md";
import { FaNotesMedical } from "react-icons/fa";
import { GoCommentDiscussion } from "react-icons/go";
import { FaUserDoctor } from "react-icons/fa6";
import { BsCapsulePill } from "react-icons/bs";

import { sxBtnSelect, sxBtnSelectA, sxBtnSelectB } from "../../components/ButtonCustomize";

function OutPatient() {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const routeState = useLocation()
    const dispatch = useDispatch()
    const [appoiontmentState, setAppointmentState] = useState([])
    const [smallScreen, setSmallScreen] = useState(false);

    if(!routeState.state){
        routeState.state = { appointment_state: 'ADD_APPOINT' }
    }

    let init_button_feature = [
        {
            name_btn: 'เพิ่มการนัดหมาย',
            state: 'ADD_APPOINT',
            icon: <IoMdAddCircleOutline/>,
            status: false
        },
        {
            name_btn: 'รายการนัดหมาย',
            state: 'NEW_APPOINT',
            icon: <GrSchedules/>,
            status: false
        },
        {
            name_btn: 'จุดคัดกรอง',
            state: 'SCREEN_APPOINT',
            icon: <MdChecklistRtl/>,
            status: false
        },
        {
            name_btn: 'เวชระเบียน',
            state: 'MEDICAL_RECORD',
            icon: <FaNotesMedical/>,
            status: false
        },
        {
            name_btn: 'ซักประวัติ',
            state: 'TAKE_HISTORY',
            icon: <GoCommentDiscussion/>,
            status: false
        },
        {
            name_btn: 'พบแพทย์',
            state: 'DOCTOR',
            icon: <FaUserDoctor/>,
            status: false
        },
        {
            name_btn: 'จุดออกใบนัด',
            state: 'NEXT_APPOINT',
            icon: <GrScheduleNew/>,
            status: false
        },
        {
            name_btn: 'จ่ายยา',
            state: 'DRUG_ORDER',
            icon: <BsCapsulePill/>,
            status: false
        },
    ]

    useEffect(() => {
        dispatch(menuActive('ผู้ป่วยนอก (ทางไกล)'))
        // findAppointmentState()
    },[])

    useEffect(() => {
        // dispatch(menuActive('ผู้ป่วยนอก (ทางไกล)'))
        findAppointmentState()
    },[])

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => { window.removeEventListener("resize", handleResize); };
    }, []);

    const handleResize = () => {
        setSmallScreen(window.innerWidth<512);
    };

    const handleManage = (state) => {
        navigate("/auth/out_patient", { state: { appointment_state: state }});
    }
    //  console.log("routeState ====> ",routeState.state['appointment_state'])

    const findAppointmentState = async () => {
        let AccessToken = localStorage.getItem("AccessToken")
        let res = await api.findAppointmentState(AccessToken)
        if (res) {
            if (res['data']['code'] === 200) {
                setAppointmentState(res['data']['data'])
                // console.log(res['data']['data'])
            }
        } else return notifyError('ไม่ตอบสนอง')
    }

    return (
        <>
            <LoaderAnimation loading={loading} />
            <Box sx={{ 
                display: 'flex', 
                flexWrap: 'wrap',
                justifyContent: 'start',
                mt: 1, ml: '3rem',
                gap: 6,
                '@media (max-width: 512px)' : {
                    justifyContent: 'space-around',
                    gap: 3, rowGap: 1.5,
                    mx: 2,
                    px: 2,
                }
            }}>
                {
                init_button_feature.map((item, index) => (
                    <Tooltip title={item['name_btn']} key={index} disabled={item['status']}>
                        <IconButton onClick={() => handleManage(item['state'],index)} aria-label={item['name_btn']} size={smallScreen?"medium":"large"} color="c_button"
                            {...(item['state'] === routeState.state['appointment_state'] && sxBtnSelect)}
                        >
                            {item['icon']}
                        </IconButton>
                    </Tooltip>
                ))

                }
            </Box>

            {routeState.state['appointment_state'] === 'ADD_APPOINT' && <AddAppointment />}
            {routeState.state['appointment_state'] === 'NEW_APPOINT' && <NewAppoint appoiontmentState={appoiontmentState} smallScreen={smallScreen} />}
            {routeState.state['appointment_state'] === 'SCREEN_APPOINT' && <FilterPoint appoiontmentState={appoiontmentState} smallScreen={smallScreen} />}
            {routeState.state['appointment_state'] === 'MEDICAL_RECORD' && <MedicalRecord appoiontmentState={appoiontmentState} smallScreen={smallScreen} />}
            {routeState.state['appointment_state'] === 'TAKE_HISTORY' && <TakeHistory appoiontmentState={appoiontmentState} smallScreen={smallScreen} />}
            {routeState.state['appointment_state'] === 'DOCTOR' && <SeeDoctor appoiontmentState={appoiontmentState} smallScreen={smallScreen} />}
            {routeState.state['appointment_state'] === 'NEXT_APPOINT' && <Appointment appoiontmentState={appoiontmentState} smallScreen={smallScreen} />}
            {routeState.state['appointment_state'] === 'DRUG_ORDER' && <DispenseMedication appoiontmentState={appoiontmentState} smallScreen={smallScreen} />}
            
        </>
    )
}

export default OutPatient